export default {
  props: {
    files: [FileList, Array],
    dist: Object,
  },
  watch: {
    files() {},
    dist() {},
  },
};
